import React, { useState, useEffect } from 'react';
import { Layout, Menu, ConfigProvider, Drawer, Button } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import './App.css';
import PackagePage from './pages/PackagePage';
import AboutPage from './pages/AboutPage';
import customTheme from './theme';

const { Header, Content } = Layout;

function App() {
  const [currentPage, setCurrentPage] = useState('package');
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  
  // 检测屏幕宽度，判断是否为移动设备
  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);
    
    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);

  const menuItems = [
    {
      key: 'package',
      label: 'Package',
    },
    // {
    //   key: 'about',
    //   label: 'About Us',
    // },
  ];

  return (
    <ConfigProvider theme={customTheme}>
      <Layout className="layout">
        <Header style={{ display: 'flex', alignItems: 'center', background: customTheme.token.colorInfo, padding: isMobile ? '0 15px' : '0 50px' }}>
          <div className="logo">
            <img src={
              require('./assets/emusprint.png')
            }
             alt="emusprint logo" />
            <span>emusprint</span>
          </div>
          
          {isMobile ? (
            <Button 
              type="text" 
              icon={<MenuOutlined />} 
              onClick={() => setDrawerVisible(true)} 
              style={{ marginLeft: 'auto', color: 'white' }}
            />
          ) : (
            <Menu
              theme="dark"
              mode="horizontal"
              selectedKeys={[currentPage]}
              items={menuItems}
              onClick={({ key }) => setCurrentPage(key)}
              style={{ marginLeft: 'auto' }}
            />
          )}
          
          {/* 移动端抽屉菜单 */}
          <Drawer
            title="菜单"
            placement="right"
            onClose={() => setDrawerVisible(false)}
            open={drawerVisible}
          >
            <Menu
              mode="vertical"
              selectedKeys={[currentPage]}
              items={menuItems}
              onClick={({ key }) => {
                setCurrentPage(key);
                setDrawerVisible(false);
              }}
              style={{ height: '100%' }}
            />
          </Drawer>
      </Header>
      <Content style={{ padding: isMobile ? '0 15px' : '0 50px', marginTop: isMobile ? 10 : 20, background: customTheme.token.colorBgLayout }}>
        <div
          style={{
            background: customTheme.token.colorBgContainer,
            minHeight: 280,
            padding: 24,
            borderRadius: customTheme.token.borderRadiusLG,
            boxShadow: customTheme.token.boxShadowSecondary,
          }}
        >
          {currentPage === 'package' ? <PackagePage /> : <AboutPage />}
        </div>
      </Content>
      </Layout>
    </ConfigProvider>
  );
}

export default App;